import React from 'react';
import css from './style.module.css';
import { getClassName } from '../../helpers/css';

const Section = ({ id = "", className = "", children }) => {
    let classes = getClassName(className, css);
    return (
        <div id={id} className={`${css.section}${classes ? " " + classes : ""}`}>
            {children}
        </div>
    )
}

export default Section;